import EditInPlace from './edit-in-place';

export default EditInPlace;